var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewReleases(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 193 190",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{stroke:#000;stroke-width:7px;}.cls-3{fill:#f60;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new_releases_black_24dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2751",
    className: "cls-1",
    d: "m4.5,5h176c2.49,0,4.5,2.01,4.5,4.5v176c0,2.49-2.01,4.5-4.5,4.5H4.5c-2.49,0-4.5-2.01-4.5-4.5V9.5c0-2.49,2.01-4.5,4.5-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2752",
    className: "cls-3",
    d: "m174.91,94.85l-15.33-17.46c-.73-.83-1.08-1.92-.98-3.02l2.14-23.11c.19-2-1.14-3.84-3.11-4.28l-22.7-5.15c-1.07-.24-2-.92-2.56-1.86l-11.88-19.98c-1.03-1.73-3.18-2.43-5.03-1.64l-21.37,9.17c-1.01.43-2.15.43-3.16,0l-21.37-9.17c-1.85-.79-4-.09-5.03,1.64l-11.88,19.97c-.56.95-1.49,1.62-2.57,1.86l-22.68,5.09c-1.97.44-3.3,2.28-3.12,4.28l2.14,23.11c.1,1.09-.25,2.18-.98,3.01l-15.35,17.54c-1.33,1.51-1.32,3.78,0,5.29l15.34,17.46c.73.83,1.08,1.92.98,3.02l-2.14,23.19c-.18,2,1.14,3.84,3.11,4.28l22.7,5.15c1.07.24,2,.92,2.56,1.86l11.88,19.97c1.03,1.73,3.19,2.43,5.04,1.63l21.37-9.23c1.01-.44,2.16-.44,3.17,0l21.37,9.17c1.85.79,4,.09,5.03-1.64l11.88-19.98c.56-.95,1.49-1.62,2.56-1.86l22.7-5.15c1.96-.45,3.29-2.28,3.11-4.28l-2.14-23.11c-.1-1.1.25-2.19.98-3.02l15.33-17.46c1.33-1.51,1.33-3.78,0-5.29Zm-81.83,35.61h-1.13c-2.22,0-4.01-1.8-4.01-4.01v-1.84c0-2.22,1.8-4.01,4.01-4.01h1.13c2.21,0,4.01,1.79,4.01,4v1.84c0,2.22-1.79,4.02-4.01,4.02Zm-.01-25.26h-1.13c-2.21,0-4.01-1.79-4.01-4l-.08-34.21c0-2.22,1.79-4.02,4.01-4.02h1.22c2.22,0,4.01,1.8,4.01,4.01l-.02,34.21c0,2.21-1.8,4.01-4.01,4.01Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "new_releases_black_24dp-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2751-2",
    className: "cls-1",
    d: "m12.5,0h176c2.49,0,4.5,2.01,4.5,4.5v176c0,2.49-2.01,4.5-4.5,4.5H12.5c-2.49,0-4.5-2.01-4.5-4.5V4.5c0-2.49,2.01-4.5,4.5-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2752-2",
    className: "cls-2",
    d: "m182.62,89.53l-14.91-16.98c-.82-.93-1.21-2.15-1.1-3.38l2.08-22.48c.21-2.25-1.28-4.3-3.48-4.8l-22.07-5.01c-1.2-.27-2.24-1.03-2.87-2.09l-11.55-19.43c-1.15-1.94-3.57-2.73-5.64-1.84l-20.79,8.92c-1.13.49-2.42.49-3.55,0l-20.79-8.92c-2.08-.89-4.49-.11-5.64,1.84l-11.55,19.43c-.63,1.06-1.68,1.82-2.88,2.09l-22.05,4.95c-2.21.5-3.7,2.55-3.5,4.81l2.08,22.47c.11,1.23-.28,2.45-1.09,3.38l-14.93,17.06c-1.49,1.7-1.48,4.24,0,5.93l14.91,16.98c.82.93,1.21,2.15,1.1,3.38l-2.08,22.56c-.21,2.25,1.28,4.3,3.49,4.8l22.08,5.01c1.2.27,2.24,1.03,2.87,2.09l11.55,19.42c1.16,1.94,3.58,2.73,5.65,1.83l20.78-8.98c1.14-.49,2.42-.49,3.56,0l20.78,8.92c2.08.89,4.49.11,5.64-1.84l11.55-19.43c.63-1.06,1.67-1.82,2.87-2.09l22.08-5.01c2.2-.5,3.69-2.55,3.48-4.8l-2.08-22.48c-.11-1.23.28-2.45,1.1-3.38l14.91-16.98c1.49-1.7,1.49-4.24,0-5.94Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1223"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1143",
    x: 96,
    y: 59,
    width: 9,
    height: 42,
    rx: 4.5,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1144",
    x: 96,
    y: 117,
    width: 9,
    height: 9,
    rx: 4.5,
    ry: 4.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewReleases);
export default __webpack_public_path__ + "static/media/new-releases.26f63db38c3528058d61159ce32bfefd.svg";
export { ForwardRef as ReactComponent };